import React from 'react'
import ReactDOM from 'react-dom'
import { CookiesProvider, Cookies } from 'react-cookie';
import App from "./App";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

ReactDOM.render(
    <CookiesProvider>
        <Router>
            <App/>
        </Router>
    </CookiesProvider>
    , document.getElementById('app'));




// WEBPACK FOOTER //
// ./src/index.js